import { render, staticRenderFns } from "./portalFrame.vue?vue&type=template&id=4bdab3b2&scoped=true"
import script from "./portalFrame.vue?vue&type=script&lang=js"
export * from "./portalFrame.vue?vue&type=script&lang=js"
import style0 from "./portalFrame.vue?vue&type=style&index=0&id=4bdab3b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdab3b2",
  null
  
)

export default component.exports